export default {
  en: {
    "tickets.label.customer.escalated": "Escalated",
    "tickets.label.customer.tickets": "Customer Ticket",
    "tickets.label.customer.entity": "Business Entity Tickets",
    "tickets.label.customer.name": "Customer Name",
    "tickets.label.customer.businessEntity": "Business Entity Name",
    "tickets.label.customer.ticket": "Ticket",
    "tickets.label.customer.ticketDate": "Ticket Date",
    "tickets.label.customer.ticketAge": "Ticket Age",
    "tickets.label.customer.priority": "Priority",
    "tickets.label.customer.category": "Category",
    "tickets.label.customer.createdBy": "Created By",
    "tickets.label.customer.assignedto": "Assigned to",
    "tickets.label.customer.closedBy": "Closed By",
    "tickets.label.customer.resolutionDate": "Resolution Date",
    "tickets.label.customer.status": "Status",
    "tickets.label.customer.action": "Actions",
    "tickets.label.edit.Priority": "Priority",
    "tickets.label.edit.Category": "Category",
    "tickets.label.edit.Team": "Team",
    "tickets.label.edit.Comment": "Comment",
    "tickets.label.edit.Ticket Date": "Ticket Date",
    "tickets.label.edit.Sub Category": "Sub Category",
    "tickets.label.edit.Team User": "Team User",
    "tickets.label.edit.Ticket Number": "Ticket Number",
    "tickets.label.edit.Assign To": "Assign To",
    "tickets.label.edit.Status": "Status",
    "tickets.label.edit.Title": "Title",
    "tickets.label.edit.header": "Edit Ticket",
    "tickets.label.edit.save": "Save",
    "tickets.label.Resolution Description": "Resolution Description",
    "tickets.label.Close Ticket": "Close Ticket",
    "ticket.label.CustomerTickets": "Customer Tickets",
    "ticket.label.EntityTickets": "Entity Tickets",
  },

  fr: {
    "tickets.label.customer.escalated": "Escaladé",
    "tickets.label.customer.tickets": "Ticket client",
    "tickets.label.customer.entity": "Ticket d'entité",
    "tickets.label.customer.name": "Nom du client",
    "tickets.label.customer.ticket": "Billet",
    "tickets.label.customer.ticketDate": "Date du billet",
    "tickets.label.customer.ticketAge": "Âge du billet",
    "tickets.label.customer.priority": "Priorité",
    "tickets.label.customer.category": "Catégorie",
    "tickets.label.customer.createdBy": "Créé par",
    "tickets.label.customer.assignedto": "Assigné à",
    "tickets.label.customer.closedBy": "Fermé par",
    "tickets.label.customer.resolutionDate": "Date de résolution",
    "tickets.label.customer.status": "Statut",
    "tickets.label.customer.action": "Action",
    "tickets.label.edit.Priority": "Priorité",
    "tickets.label.edit.Category": "Catégorie",
    "tickets.label.edit.Team": "Équipe",
    "tickets.label.edit.Comment": "Commentaire",
    "tickets.label.edit.Ticket Date": "Date du ticket",
    "tickets.label.edit.Sub Category": "Sous-catégorie",
    "tickets.label.edit.Team User": "Utilisateur de l'équipe",
    "tickets.label.edit.Ticket Number": " Numéro de ticket",
    "tickets.label.edit.Assign To": "Assigner à",
    "tickets.label.edit.Status": "Statut",
    "tickets.label.edit.Title": "Titre",
    "tickets.label.edit.header": "Modifier le ticket",
    "tickets.label.edit.save": "Enregistrer",
    "tickets.label.Resolution Description": "Description de la résolution",
    "tickets.label.Close Ticket": "Fermer le ticket",
    "ticket.label.CustomerTickets": "Tickets Client",
    "ticket.label.EntityTickets": "Tickets Entité",
  },

  es: {
    "tickets.label.customer.escalated": "Escalado",
    "tickets.label.customer.tickets": "Ticket del cliente",
    "tickets.label.customer.entity": "Ticket de entidad",
    "tickets.label.customer.name": "Nombre del cliente",
    "tickets.label.customer.ticket": "Ticket",
    "tickets.label.customer.ticketDate": "Fecha del ticket",
    "tickets.label.customer.ticketAge": "Antigüedad del ticket",
    "tickets.label.customer.priority": "Prioridad",
    "tickets.label.customer.category": "Categoría",
    "tickets.label.customer.createdBy": "Creado por",
    "tickets.label.customer.assignedto": "Asignado a",
    "tickets.label.customer.closedBy": "Cerrado por",
    "tickets.label.customer.resolutionDate": "Fecha de Resolución",
    "tickets.label.customer.status": "Estado",
    "tickets.label.customer.action": "Acción",
    "tickets.label.edit.Priority": "Prioridad",
    "tickets.label.edit.Category": "Categoría",
    "tickets.label.edit.Team": "Equipo",
    "tickets.label.edit.Comment": "Comentario",
    "tickets.label.edit.Ticket Date": "Fecha del Ticket",
    "tickets.label.edit.Sub Category": "Subcategoría",
    "tickets.label.edit.Team User": "Usuario del equipo",
    "tickets.label.edit.Ticket Number": "Número de ticket",
    "tickets.label.edit.Assign To": "Asignar a",
    "tickets.label.edit.Status": "Estado",
    "tickets.label.edit.Title": "Título",
    "tickets.label.edit.header": "Editar ticket",
    "tickets.label.edit.save": "Guardar",
    "tickets.label.Resolution Description": "Descripción de la resolución",
    "tickets.label.Close Ticket": "Cerrar ticket",
    "ticket.label.CustomerTickets": "Tickets de Cliente",
    "ticket.label.EntityTickets": "Tickets de Entidad",
  },

  pt: {
    "tickets.label.customer.escalated": "Escalado",
    "tickets.label.customer.tickets": "Bilhete do cliente",
    "tickets.label.customer.entity": "Ticket de Entidade",
    "tickets.label.customer.name": "Nome do Cliente",
    "tickets.label.customer.ticket": "Bilhete",
    "tickets.label.customer.ticketDate": "Data do Bilhete",
    "tickets.label.customer.ticketAge": "Idade do Bilhete",
    "tickets.label.customer.priority": "Prioridade",
    "tickets.label.customer.category": "Categoria",
    "tickets.label.customer.createdBy": "Criado por",
    "tickets.label.customer.assignedto": "Atribuído a",
    "tickets.label.customer.closedBy": "Fechado por",
    "tickets.label.customer.resolutionDate": "Data de resolução",
    "tickets.label.customer.status": "Estado",
    "tickets.label.customer.action": "Ação",
    "tickets.label.edit.Priority": "Prioridade",
    "tickets.label.edit.Category": "Categoria",
    "tickets.label.edit.Team": "Equipe",
    "tickets.label.edit.Comment": "Comentário",
    "tickets.label.edit.Ticket Date": "Data do Ticket",
    "tickets.label.edit.Sub Category": "Subcategoria",
    "tickets.label.edit.Team User": "Usuário da equipe",
    "tickets.label.edit.Ticket Number": " Número do Ticket",
    "tickets.label.edit.Assign To": "Atribuir a",
    "tickets.label.edit.Status": "Estado",
    "tickets.label.edit.Title": "Título",
    "tickets.label.edit.header": "Editar Ticket",
    "tickets.label.edit.save": "Salvar",
    "tickets.label.Resolution Description": "Descrição da Resolução",
    "tickets.label.Close Ticket": "Fechar Ticket",
    "ticket.label.CustomerTickets": "Tickets de Cliente",
    "ticket.label.EntityTickets": "Tickets de Entidade",
  },

  zh_CN: {
    "tickets.label.customer.escalated": "升级",
    "tickets.label.customer.tickets": "客户票",
    "tickets.label.customer.entity": "实体票",
    "tickets.label.customer.name": "客户姓名",
    "tickets.label.customer.ticket": "票",
    "tickets.label.customer.ticketDate": "票日期",
    "tickets.label.customer.ticketAge": "票龄",
    "tickets.label.customer.priority": "优先级",
    "tickets.label.customer.category": "类别",
    "tickets.label.customer.createdBy": "创建者",
    "tickets.label.customer.assignedto": "分配给",
    "tickets.label.customer.closedBy": "关闭者",
    "tickets.label.customer.resolutionDate": "決議日期",
    "tickets.label.customer.status": "状态",
    "tickets.label.customer.action": "操作",
    "tickets.label.edit.Priority": "优先级",
    "tickets.label.edit.Category": "类别",
    "tickets.label.edit.Team": "团队",
    "tickets.label.edit.Comment": "评论",
    "tickets.label.edit.Ticket Date": "票据日期",
    "tickets.label.edit.Sub Category": "子类别",
    "tickets.label.edit.Team User": "团队用户",
    "tickets.label.edit.Ticket Number": "票号",
    "tickets.label.edit.Assign To": "分配给",
    "tickets.label.edit.Status": "状态",
    "tickets.label.edit.Title": "标题",
    "tickets.label.edit.header": "编辑工单",
    "tickets.label.edit.save": "保存",
    "tickets.label.Resolution Description": "解决方案描述",
    "tickets.label.Close Ticket": "关闭工单",
    "ticket.label.CustomerTickets": "客户工单",
    "ticket.label.EntityTickets": "实体工单",
  },

  hi: {
    "tickets.label.customer.escalated": "उन्नत",
    "tickets.label.customer.tickets": "ग्राहक टिकट",
    "tickets.label.customer.entity": "एंटिटी टिकट",
    "tickets.label.customer.name": "ग्राहक का नाम",
    "tickets.label.customer.ticket": "टिकट",
    "tickets.label.customer.ticketDate": "टिकट की तारीख",
    "tickets.label.customer.ticketAge": "टिकट की आयु",
    "tickets.label.customer.priority": "प्राथमिकता",
    "tickets.label.customer.category": "श्रेणी",
    "tickets.label.customer.createdBy": "द्वारा बनाया गया",
    "tickets.label.customer.assignedto": "किसे असाइन किया गया है",
    "tickets.label.customer.closedBy": "द्वारा बंद किया गया",
    "tickets.label.customer.resolutionDate": "समाधान तिथि",
    "tickets.label.customer.status": "स्थिति",
    "tickets.label.customer.action": "कार्रवाई",
    "tickets.label.edit.Priority": "प्राथमिकता",
    "tickets.label.edit.Category": "श्रेणी",
    "tickets.label.edit.Team": "टीम",
    "tickets.label.edit.Comment": "टिप्पणी",
    "tickets.label.edit.Ticket Date": "टिकट तिथि",
    "tickets.label.edit.Sub Category": "उप-श्रेणी",
    "tickets.label.edit.Team User": "टीम उपयोगकर्",
    "tickets.label.edit.Ticket Number": "टिकट संख्",
    "tickets.label.edit.Assign To": "सौंपें को",
    "tickets.label.edit.Status": "स्थिति",
    "tickets.label.edit.Title": "शीर्षक",
    "tickets.label.edit.header": "टिकट संपादित करें",
    "tickets.label.edit.save": "सहेजें",
    "tickets.label.Resolution Description": "समाधान विवरण",
    "tickets.label.Close Ticket": "टिकट बंद करें",
    "ticket.label.CustomerTickets": "ग्राहक टिकट",
    "ticket.label.EntityTickets": "संगठन टिकट",
  },

  ka: {
    "tickets.label.customer.escalated": "ಎಸ್ಕಲೇಟೆಡ್",
    "tickets.label.customer.tickets": "მომხმარებლის ბილეთი",
    "tickets.label.customer.entity": "ენთიტის ბილეთი",
    "tickets.label.customer.name": "მომხმარებლის სახელი",
    "tickets.label.customer.ticket": "ბილეთი",
    "tickets.label.customer.ticketDate": "ბილეთის თარიღი",
    "tickets.label.customer.ticketAge": "ბილეთის ასაკი",
    "tickets.label.customer.priority": "პრიორიტეტი",
    "tickets.label.customer.category": "კატეგორია",
    "tickets.label.customer.createdBy": "შექმნილია",
    "tickets.label.customer.assignedto": "მიკუთვნებულია",
    "tickets.label.customer.closedBy": "დახურულია",
    "tickets.label.customer.resolutionDate": "გადაწყვეტის თარიღი",
    "tickets.label.customer.status": "სტატუსი",
    "tickets.label.customer.action": "ქმედება",
    "tickets.label.edit.Priority": "პრიორიტეტი",
    "tickets.label.edit.Category": "კატეგორია",
    "tickets.label.edit.Team": "გუნდი",
    "tickets.label.edit.Comment": "კომენტარი",
    "tickets.label.edit.Ticket Date": "ბილეთის თარიღი",
    "tickets.label.edit.Sub Category": "ქვეკატეგორია",
    "tickets.label.edit.Team User": "გუნდის მომხმარებელი",
    "tickets.label.edit.Ticket Number": "ბილეთის ნომერი",
    "tickets.label.edit.Assign To": "დანიშნული",
    "tickets.label.edit.Status": "სტატუსი",
    "tickets.label.edit.Title": "სათაური",
    "tickets.label.edit.header": "ბილეთის რედაქტირება",
    "tickets.label.edit.save": "შენახვა",
    "tickets.label.Resolution Description": "გადაწყვეტილების აღწერა",
    "tickets.label.Close Ticket": "ბილეთის დახურვა",
    "ticket.label.CustomerTickets": "კლიენტის ბილეთები",
    "ticket.label.EntityTickets": "ენთიტეტის ბილეთები",
  },

  lo: {
    "tickets.label.customer.escalated": "ຍ່າງຂຶ້ນ",
    "tickets.label.customer.tickets": " ເວັບໄຊທີ່ມີຜູ້ຂາຍ",
    "tickets.label.customer.entity": "ປ້ອນຂໍ້ມູນບໍ່ໃຫ້ໃສ່",
    "tickets.label.customer.name": "ຊື່ລູກຄ້າ",
    "tickets.label.customer.ticket": "ບິນ",
    "tickets.label.customer.ticketDate": "ວັນທີໃບ",
    "tickets.label.customer.ticketAge": "ອາຍຸແລ້ວ",
    "tickets.label.customer.priority": "ສະຖານະຕິດຕໍ່",
    "tickets.label.customer.category": "ໝວດ",
    "tickets.label.customer.createdBy": "ສ້າງໂດຍ",
    "tickets.label.customer.assignedto": "ມັນໄດ້ຖືກນຳໃຊ້",
    "tickets.label.customer.closedBy": "ປິດໃຊ້ໄດ້ແລ້ວ",
    "tickets.label.customer.resolutionDate": "ວັນທີການແກ້ໄຂ",
    "tickets.label.customer.status": "ສະຖານະ",
    "tickets.label.customer.action": "ການປະມວນ",
    "tickets.label.edit.Priority": "ສິດທິຫາຍ",
    "tickets.label.edit.Category": "ຫມວດຫມາຍ",
    "tickets.label.edit.Team": "ທີມ",
    "tickets.label.edit.Comment": "ຄຳເຫັນ",
    "tickets.label.edit.Ticket Date": "ວັນທີຂອງບິນ",
    "tickets.label.edit.Sub Category": "ຫມວດຫມາຍຍ່ອຍ",
    "tickets.label.edit.Team User": "ຜູ້ໃຊ້ທີມ",
    "tickets.label.edit.Ticket Number": "ຈໍານວນບິນ",
    "tickets.label.edit.Assign To": "ການຈັດອອກເຂົ້າ",
    "tickets.label.edit.Status": "ສະຖານະ",
    "tickets.label.edit.Title": "ຊື່",
    "tickets.label.edit.header": "ແກ້ໄຂເຄື່ອງ",
    "tickets.label.edit.save": "ບັນທຶກ",
    "tickets.label.Resolution Description": "ລາຍການຮຽບຮ້ອຍ",
    "tickets.label.Close Ticket": "ປິດເຄື່ອງ",
    "ticket.label.CustomerTickets": "ເລືອກຂໍ້ມູນລູກຄ້າ",
    "ticket.label.EntityTickets": "ເລືອກຂໍ້ມູນແອັບ",
  },

  my_MM: {
    "tickets.label.customer.escalated": "တက်ကြွစေသည်",
    "tickets.label.customer.tickets": "ကုန်ပစ္စည်းလက်မှတ်",
    "tickets.label.customer.entity": "အမျိုးအစားလက်မှတ်",
    "tickets.label.customer.name": "ဖော်ပြထားသူအမည်",
    "tickets.label.customer.ticket": "လက်မှတ်",
    "tickets.label.customer.ticketDate": "လက်ကျန်သည့်နေ့ရက်",
    "tickets.label.customer.ticketAge": "လက်မှတ်အသက်",
    "tickets.label.customer.priority": "အလှပ်ကန့်",
    "tickets.label.customer.category": "အမျိုးအစား",
    "tickets.label.customer.createdBy": "ဖြန့်ဆွဲသူ",
    "tickets.label.customer.assignedto": "တပ်ဆင်ထားသူ",
    "tickets.label.customer.closedBy": "ပိတ်ထားသူ",
    "tickets.label.customer.resolutionDate": "ဖြေရှင်းချက်ရက်စွဲ",
    "tickets.label.customer.status": "အခြေအနေ",
    "tickets.label.customer.action": "လုပ်ဆောင်ချက်",
    "tickets.label.edit.Priority": "အဖြစ်အမြင့်",
    "tickets.label.edit.Category": "အမျိုးအစား",
    "tickets.label.edit.Team": "အဖွဲ့",
    "tickets.label.edit.Comment": "မှတ်ချက်",
    "tickets.label.edit.Ticket Date": "လက်ခံရက်",
    "tickets.label.edit.Sub Category": "အမျိုးအစားအကြောင်း",
    "tickets.label.edit.Team User": "အဖွဲ့အသုံးပြုသူ",
    "tickets.label.edit.Ticket Number": "ဘီလ်တပ်နံပါတ်",
    "tickets.label.edit.Assign To": "အတည်ပြုပြီးသောသူ",
    "tickets.label.edit.Status": "အဆင့်အတန်း",
    "tickets.label.edit.Title": "ခေါင်းစဉ်",
    "tickets.label.edit.header": "ထုတ်ဝေခြင်",
    "tickets.label.edit.save": "သိမ်းမည်",
    "tickets.label.Resolution Description": "အကြောင်းအရာကိုဖျက်ပါ",
    "tickets.label.Close Ticket": "ထုတ်ဝေခြင်းပိတ်ပါ",
    "ticket.label.CustomerTickets": "သုံးစွဲသူ ဆေးရုံများ",
    "ticket.label.EntityTickets": "Entity Tickets",
  },

  my: {
    "tickets.label.customer.escalated": "တက်ကြွစေသည်",
    "tickets.label.customer.tickets": "ကုန်ပစ္စည်းလက်မှတ်",
    "tickets.label.customer.entity": "အမျိုးအစားလက်မှတ်",
    "tickets.label.customer.name": "ဖော်ပြထားသူအမည်",
    "tickets.label.customer.ticket": "လက်မှတ်",
    "tickets.label.customer.ticketDate": "လက်ကျန်သည့်နေ့ရက်",
    "tickets.label.customer.ticketAge": "လက်မှတ်အသက်",
    "tickets.label.customer.priority": "အလှပ်ကန့်",
    "tickets.label.customer.category": "အမျိုးအစား",
    "tickets.label.customer.createdBy": "ဖြန့်ဆွဲသူ",
    "tickets.label.customer.assignedto": "တပ်ဆင်ထားသူ",
    "tickets.label.customer.closedBy": "ပိတ်ထားသူ",
    "tickets.label.customer.resolutionDate": "ဖြေရှင်းချက်ရက်စွဲ",
    "tickets.label.customer.status": "အခြေအနေ",
    "tickets.label.customer.action": "လုပ်ဆောင်ချက်",
    "tickets.label.edit.Priority": "အကြောင်းအရာ",
    "tickets.label.edit.Category": "အမျိုးအစား",
    "tickets.label.edit.Team": "အဖွဲ့",
    "tickets.label.edit.Comment": "မှတ်ချက်",
    "tickets.label.edit.Ticket Date": "လက်ခံရက်",
    "tickets.label.edit.Sub Category": "အမျိုးအစားအကြောင်း",
    "tickets.label.edit.Team User": "အဖွဲ့အသုံးပြုသူ",
    "tickets.label.edit.Ticket Number": "ဘီလ်တပ်နံပါတ်",
    "tickets.label.edit.Assign To": "အတည်ပြုပြီးသောသူ",
    "tickets.label.edit.Status": "အဆင့်အတန်း",
    "tickets.label.edit.Title": "ခေါင်းစဉ်",
    "tickets.label.edit.header": "ထုတ်ဝေခြင်း",
    "tickets.label.edit.save": "သိမ်းမည်",
    "tickets.label.Resolution Description": "အကြောင်းအရာကိုဖျက်ပါ",
    "tickets.label.Close Ticket": "ထုတ်ဝေခြင်းပိတ်ပါ",
    "ticket.label.CustomerTickets": "သုံးစွဲသူ ဆေးရုံများ",
    "ticket.label.EntityTickets": "Entity Tickets",
  },

  vi: {
    "tickets.label.customer.escalated": "Nâng cao",
    "tickets.label.customer.tickets": "Vé khách hàng",
    "tickets.label.customer.entity": "Vé thực thể",
    "tickets.label.customer.name": "Tên Khách hàng",
    "tickets.label.customer.ticket": "Vé",
    "tickets.label.customer.ticketDate": "Ngày Vé",
    "tickets.label.customer.ticketAge": "Tuổi Vé",
    "tickets.label.customer.priority": "Ưu tiên",
    "tickets.label.customer.category": "Danh mục",
    "tickets.label.customer.createdBy": "Được tạo bởi",
    "tickets.label.customer.assignedto": "Được giao cho",
    "tickets.label.customer.closedBy": "Đã đóng",
    "tickets.label.customer.resolutionDate": "Ngày quyết định",
    "tickets.label.customer.status": "Trạng thái",
    "tickets.label.customer.action": "Hành động",
    "tickets.label.edit.Priority": "Ưu tiên",
    "tickets.label.edit.Category": "Danh mục",
    "tickets.label.edit.Team": "Nhóm",
    "tickets.label.edit.Comment": "Bình luận",
    "tickets.label.edit.Ticket Date": "Ngày Ticket",
    "tickets.label.edit.Sub Category": "Tiểu mục",
    "tickets.label.edit.Team User": "Người dùng Nhóm",
    "tickets.label.edit.Ticket Number": " Số vé",
    "tickets.label.edit.Assign To": "Phân công cho",
    "tickets.label.edit.Status": "Trạng thái",
    "tickets.label.edit.Title": "Tiêu đề",
    "tickets.label.edit.header": "Chỉnh sửa Ticket",
    "tickets.label.edit.save": "Lưu",
    "tickets.label.Resolution Description": "Mô tả Giải quyết",
    "tickets.label.Close Ticket": "Đóng Ticket",
    "ticket.label.CustomerTickets": "Vé Khách Hàng",
    "ticket.label.EntityTickets": "Vé Thực Thể",
  },
};
